import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "../../../../../../../util/Table/.mixins/Table";
import Filter from "../../../../../../../util/filter/.mixins/Filter";

//css
import ProdutosCss from './ProdutosLista-css';
const useStyles = ProdutosCss();

export default function ProdutosLista(props) {
    const classes = useStyles();
    return (
        <div className="container">

            {props.state.isLoading &&
            <div align="center">
                <CircularProgress />
            </div>
            }
            {!props.state.isLoading &&
            <div>
                {/* <Filter {...props}/> */}
                <br/>
                <Table {...props} className={classes.root}/>
            </div>
            }

        </div>
    );
}